import { useEffect } from "react";

const GTranslateWidget = () => {
  useEffect(() => {
    // Set up GTranslate settings
    (window as any).gtranslateSettings = {
      default_language: "en",
      languages: ["en", "es"],
      wrapper_selector: ".gtranslate_wrapper"
    };

    // Load GTranslate script
    const script = document.createElement("script");
    script.src = "https://cdn.gtranslate.net/widgets/latest/float.js";
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return <div className="gtranslate_wrapper"></div>;
};

export default GTranslateWidget;
